<template>
  <v-container fluid style="max-width: 99% !important;padding-bottom: 125px;">
    <v-row>
      <v-col sm="4" lg="3" cols="12" class="pb-5" style="max-height: 60px;">
        <v-text-field solo :label="$t('search')" append-icon="mdi-magnify" single-line v-model="search"
          :color="colorTheme"></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" class="pb-5">
        <v-btn style="width: 100%; margin: 0;" large :color="colorTheme" class="regularText white--text"
          v-on:click="exportToExcel()">
          {{ $t("download").toUpperCase() }}
          <v-icon class="icon-size pl-4" right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6" sm="12" md="8">
        <v-data-table 
          :headers="headersAlertruckVehiclesInfo" 
          :items="itemsAlertruckVehiclesInfo" 
          :items-per-page="10"
          :search="search"
          :no-data-text="$t('noResults')"
          :loading="progressAlertruckVehiclesInfo"
          :loading-text="$t('loadingTextForTable')"
          class="myTableTD elevation-1"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
        >
        <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template
            v-slot:footer.page-text="items"
          >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "alertruckVehiclesInfo",
  data() {
    return {
      search: ""
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      this.$t("vehicleInformation"),
      "",
      "",
      true
    ]);

    this.$store.dispatch("getAlertruckVehiclesInfo");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersAlertruckVehiclesInfo",
      "itemsAlertruckVehiclesInfo",
      "progressAlertruckVehiclesInfo"
    ]),
  },
  watch: {},
  mounted() { },
  methods: {
    exportToExcel() {
      this.$store.dispatch("exportExcelAlertruckVehiclesInfo");
    },
  }
};
</script>

<style></style>